exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".RightSidebar-4243c17d{display:flex;flex-flow:column;height:100%;font-size:15px;line-height:22px}.returnToPlanner-7705aea9{cursor:pointer;background:#e0e0e0;color:#616161;font-weight:500;font-size:13px;line-height:17px;padding:16px 0;display:flex;align-items:center}.returnToPlanner-7705aea9 svg{margin:0 10px}.header-a2ee845c{background-color:#6982FF;color:#fff;padding:15px;text-align:center;font-size:16px;line-height:20px}.scrollContainer-b0fbf8b1{overflow-y:auto;flex:0 1 auto;height:100%}.topHalf-c99970ae{padding:15px 10px}.bottomHalf-bcf2317e{border-top:1px solid #E0E0E0;padding:10px}\n", ""]);

// Exports
exports.locals = {
	"RightSidebar": "RightSidebar-4243c17d",
	"returnToPlanner": "returnToPlanner-7705aea9",
	"header": "header-a2ee845c",
	"scrollContainer": "scrollContainer-b0fbf8b1",
	"topHalf": "topHalf-c99970ae",
	"bottomHalf": "bottomHalf-bcf2317e"
};